export const lineHeights = {
    heading: 1.15,
    body: 1.35,
    medium: 1.25,
    small: 1,
};
